/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Directive, Input } from '@angular/core';
import { AppRouter } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { RouteDataService } from '@gh/core-data';
import { setQueryParameters } from '@gh/core-util';

/**
 * Adds focusedId for parentRoute query parameter of current route.
 */
@Directive({
  standalone: false,
  selector: '[ghRouterParentFocusedId]',
})
export class RouterParentFocusedIdDirective {
  private _focusedId: ID;

  @Input('ghRouterParentFocusedId')
  set focusedId(focusedId: ID) {
    this._focusedId = focusedId;
    if (this.router.parentRoute) {
      this.routeData.mergeQueryParams({
        parentRoute: setQueryParameters(this.router.parentRoute, { focusedId }),
      });
    } else {
      console.error('ghRouterParentFocusedId: parentRoute does not set on the current route');
    }
  }

  get focusedId(): ID {
    return this._focusedId;
  }

  constructor(private router: AppRouter, private routeData: RouteDataService) {

  }
}
